import React from 'react';
import styles from './customerSpecialRequest.module.css';
import { useTranslation } from 'react-i18next';

const CustomerSpecialRequest = ({ values, handleChange, open, setOpen, title }) => {
  const { t } = useTranslation();
  return (
    <div>
      <div className='fw-semibold text-primary font-tiny' onClick={() => setOpen(!open)}>
        {title ? title : t('specialRequest')}
      </div>

      <div className={`mt-3 ${styles.textareaContainer} fade-up`}>
        <textarea
          name='comments'
          value={values.comments}
          onChange={handleChange}
          className={`p-3 ${styles.textarea} `}
        />
      </div>
    </div>
  );
};

export default CustomerSpecialRequest;
